import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComplaintsRoutingModule } from './complaints-routing.module';
import { ComplaintsListComponent } from './complaints-list/complaints-list.component';
import { CoreModule } from '../core/core.module';
import { ReportProblemComponent } from './report-problem/report-problem.component';
import { SharedModule } from '../shared/shared.module';
import { AngularFileUploaderModule } from 'angular-file-uploader';
import { ComplaintsService } from './complaints.service';
import { UploadImagesComponent } from './upload-images/upload-images.component';
import { ComplaintsDetailComponent } from '../complaints/complaints-detail/complaints-detail.component';
import { MyComplaintComponent } from './my-complaint/my-complaint.component';
import { MyComplaintDetailComponent } from './my-complaint-detail/my-complaint-detail.component';
import { ComplaintDetailInappropriateComponent } from './complaint-detail-inappropriate/complaint-detail-inappropriate.component';
import { ComplaintsStatisticComponent } from './complaints-statistic/complaints-statistic.component';

@NgModule({
    declarations: [ComplaintsListComponent, ReportProblemComponent, UploadImagesComponent, ComplaintsDetailComponent, MyComplaintComponent, MyComplaintDetailComponent, ComplaintDetailInappropriateComponent, ComplaintsStatisticComponent],
    imports: [
        CommonModule,
        ComplaintsRoutingModule,
        CoreModule,
        SharedModule,
        AngularFileUploaderModule
    ],
    providers: [ComplaintsService]
})
export class ComplaintsModule { }
